import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=60d0d31c&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&id=60d0d31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0d31c",
  null
  
)

export default component.exports